module.exports = __webpack_public_path__ + "static/media/sj.620e896d.svg";